import { render, staticRenderFns } from "./CashAccount.vue?vue&type=template&id=6b845cf5&scoped=true&"
import script from "./CashAccount.vue?vue&type=script&lang=js&"
export * from "./CashAccount.vue?vue&type=script&lang=js&"
import style0 from "./CashAccount.vue?vue&type=style&index=0&id=6b845cf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b845cf5",
  null
  
)

export default component.exports